module.exports = __webpack_public_path__ + "assets/img/tx12g_3.986d541e.jpg";